import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IProduct } from "@bca-shared/models/product";
import { ProductIdentifier } from "@bca-shared/models/_enums";
import { AvoService } from "@bca-shared/utils/avo/avo.service";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import { AvoDataTransformService } from "@bca-shared/utils/avo/avo-data-transform.service";


@Component({
  selector: "bca-product-card",
  templateUrl: "./product-card.component.html",
  styleUrls: ["./product-card.component.scss"],
})
export class ProductCardComponent  {
  @Input()
  product: IProduct;
  @Input()
  configuredProduct: IProduct;
  @Input()
  isSelected: boolean;
  @Input()
  isPreSelected: boolean;
  @Input()
  routeLoading: boolean;
  @Input()
  isMobileView: boolean;
  @Input()
  hideSticker: boolean;

  @Output()
  selected = new EventEmitter<IProduct>();
  @Output()
  chooseRoute = new EventEmitter<void>();
  @Output()
  readMore = new EventEmitter<IProduct>();

  ProductIdentifier = ProductIdentifier;

  constructor(private _avoService: AvoService, private _avoTransformService: AvoDataTransformService) {}

  selectProduct(): void {
    const { isSelected, selected, configuredProduct, product, chooseRoute } =
      this;

    const { identifier } = product;

    if (!configuredProduct && identifier === ProductIdentifier.Traject) {
      chooseRoute.emit();
      return;
    }

    if (!isSelected) {
      return selected.emit(configuredProduct ? configuredProduct : product);
    }
  }

  emitReadMore(product: IProduct):void {
    const viewItemData = this._avoTransformService.transformViewItemAction(product);
    this._avoService.viewItem(viewItemData)
    this.readMore.emit(product)
  }
}
